import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../store';
import { loadReportAndRequestInfo } from '../../api';
import { CustomContentInfo } from './types';
import InfoRequestDropDown from './dropdown';

const InfoRequest: React.FC = () => {
  const token = useSelector(
    (state: AppState) => state.auth.user?.access_token ?? ''
  );
  const [infoTypes, setInfoTypes] = useState<CustomContentInfo[]>([]);

  useEffect(() => {
    if (token !== '') {
      loadReportAndRequestInfo(token).then((resp) => {
        const { data } = resp;
        setInfoTypes(data);
      });
    }
  }, [token]);

  if (infoTypes.length === 0) {
    return null;
  }
  return (
    <>
      {infoTypes.map((x) => (
        <InfoRequestDropDown key={x.id} {...x} />
      ))}
    </>
  );
};

export default InfoRequest;
